import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import AutoFormGroup from '../auto-form-group/auto-form-group.vue';
import VuexFormProvider from '../vuex-form-provider/vuex-form-provider.vue';
import DisplayForm from '@shared/components/forms/auto-form/display-form/display-form.vue';
import FooterInfo from '@shared/components/forms/auto-form/footer-info/footer-info.vue';

@Component({
  name: 'bpc-stdx-form',
  components: {
    'bpc-auto-form-group': AutoFormGroup,
    'bpc-vuex-form-provider': VuexFormProvider,
    'bpc-display-form': DisplayForm,
    'bpc-footer-info': FooterInfo,
  },
})
export default class StdxForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof VuexFormProvider> & {
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      searchEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      disabled: boolean;
      errorsObject: object;
    };
    autoFormGroup: InstanceType<typeof AutoFormGroup> & {
      onDeleteMediaFile(): void;
    };
  };

  @Prop(String) readonly entity: string;
  @Prop(String) readonly permissionEntityName: string;
  @Prop({ type: String, default: 'default' }) readonly formConfigName: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: AnyEntity;
  @Prop(String) readonly mode: string;
  @Prop([String, Object, Array]) readonly extraData: string | AnyEntity;
  @Prop({ type: Boolean, default: true }) readonly fetchEntity: boolean;

  @Prop({ type: String, default: 'global.generic.successful_action' })
  readonly createdSuccessText: string;
  @Prop({ type: String, default: 'global.generic.successful_action' })
  readonly updatedSuccessText: string;
  @Prop(String) readonly storeName: string;
  @Prop({ type: Boolean, default: false }) readonly withDraft: boolean;

  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;

  public get formModel(): AnyEntity {
    return this.$store.getters[`${this.storeName}/model`];
  }

  public set formModel(val: AnyEntity) {
    this.$emit('input', val);
    this.$store.commit(`${this.storeName}/setModel`, val);
  }

  public get initialized(): boolean {
    return this.$store.getters[`${this.storeName}/initialized`];
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  async saveEntity(): Promise<BPCGenericApiResponse> {
    return await this.$refs.formProvider.saveEntity(this.formModel);
  }

  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }

  onEntitySearched(e) {
    this.$emit('entity-searched', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  async searchEntity(): Promise<BPCGenericApiResponse> {
    return await this.$refs.formProvider.searchEntity(this.formModel);
  }

  public onDeleteMediaFile() {
    // TODO: Implement with Vuex because we need to refresh the form that start the action.
    // this.formModel.resources = null;
    // this.$refs.autoFormGroup.onDeleteMediaFile();
  }

  onModelLoaded(e) {
    this.$emit('model-loaded', e);
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }

  disabledForm() {
    return this.$refs.formProvider && (this.$refs.formProvider.disabled || this.disabled);
  }

  get totalErrors() {
    return Object.entries(this.$refs.formProvider?.errorsObject || {}).filter(
      field => field[1].error !== null,
    ).length;
  }
}
